import axios from "../../axiosInstance";
import {
  ADMISSION_CREATE_REQUEST,
  ADMISSION_CREATE_SUCCESS,
  ADMISSION_CREATE_FAIL,

  ADMISSION_GET_ALL_REQUEST,
  ADMISSION_GET_ALL_SUCCESS,
  ADMISSION_GET_ALL_FAIL,

  ADMISSION_GET_ONE_REQUEST,
  ADMISSION_GET_ONE_SUCCESS,
  ADMISSION_GET_ONE_FAIL,

  ADMISSION_UPDATE_REQUEST,
  ADMISSION_UPDATE_SUCCESS,
  ADMISSION_UPDATE_FAIL,

  ADMISSION_DELETE_REQUEST,
  ADMISSION_DELETE_SUCCESS,
  ADMISSION_DELETE_FAIL,

  CLEAR_ERRORS,
} from "../constants/admissionConstants";


// ➤ Create Admission
export const createAdmission = (formData, transactionId,) => async (dispatch) => {
  try {
    dispatch({ type: ADMISSION_CREATE_REQUEST });

    const { data } = await axios.post("/api/v1/admission-form", formData, transactionId);

    dispatch({ type: ADMISSION_CREATE_SUCCESS, payload: data.data });
  } catch (error) {
    dispatch({
      type: ADMISSION_CREATE_FAIL,
      payload: error?.response?.data?.message,
    });
  }
};


// ➤ Get All Admissions
export const getAllAdmissions = () => async (dispatch) => {
  try {
    dispatch({ type: ADMISSION_GET_ALL_REQUEST });

    const { data } = await axios.get("/api/v1/admission-form");

    dispatch({ type: ADMISSION_GET_ALL_SUCCESS, payload: data.data });
  } catch (error) {
    dispatch({
      type: ADMISSION_GET_ALL_FAIL,
      payload: error?.response?.data?.message,
    });
  }
};


// ➤ Get Single Admission
export const getAdmissionById = (id) => async (dispatch) => {
  try {
    dispatch({ type: ADMISSION_GET_ONE_REQUEST });

    const { data } = await axios.get(`/api/v1/admission-form/${id}`);

    dispatch({ type: ADMISSION_GET_ONE_SUCCESS, payload: data.data });
  } catch (error) {
    dispatch({
      type: ADMISSION_GET_ONE_FAIL,
      payload: error?.response?.data?.message,
    });
  }
};


// ➤ Update Admission
export const updateAdmission = (id, formData) => async (dispatch) => {
  try {
    dispatch({ type: ADMISSION_UPDATE_REQUEST });

    const { data } = await axios.put(`/api/v1/admission-form/${id}`, formData);

    dispatch({ type: ADMISSION_UPDATE_SUCCESS, payload: data.data });
  } catch (error) {
    dispatch({
      type: ADMISSION_UPDATE_FAIL,
      payload: error?.response?.data?.message,
    });
  }
};


// ➤ Delete Admission
export const deleteAdmission = (id) => async (dispatch) => {
  try {
    dispatch({ type: ADMISSION_DELETE_REQUEST });

    await axios.delete(`/api/v1/admission-form/${id}`);

    dispatch({
      type: ADMISSION_DELETE_SUCCESS,
      payload: "Admission Deleted Successfully",
    });
  } catch (error) {
    dispatch({
      type: ADMISSION_DELETE_FAIL,
      payload: error?.response?.data?.message,
    });
  }
};


// ➤ Clear Errors
export const clearErrors = () => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
};
